// extracted by mini-css-extract-plugin
export var text = "_bp-0";